import Image from 'next/image'
import styles from './IndustryHighlights.module.scss'

export default function ContentwithImages(props) {
  const { industryHighlights } = props.fields

  return (
    <div className={styles.industryHighlights} data-aos="fade-up">
      <div className={styles.industryHighlightsWrapper}>
        {industryHighlights.map((highlight, index) => {
          if (highlight && (highlight.industryHeadline || highlight.industryDescription || highlight.industryIcon)) {
            return (
              <div key={index} className={styles.highlight}>
                <div className={styles.highlightFirstRow}>
                  {highlight.industryIcon && (
                    <Image
                      src={highlight.industryIcon.node.sourceUrl}
                      alt={highlight.industryHeadline || 'Industry Icon'}
                      width={50}
                      height={50}
                    />
                  )}
                  <h3>{highlight.industryHeadline}</h3>
                </div>
                <p>{highlight.industryDescription}</p>
              </div>
            )
          }
          return null
        })}
      </div>
    </div>
  )
}
